import {Activity, AlertCircle, Calendar, Loader2, RefreshCcw} from "lucide-react";
import DatePicker from "../../../../components/dashboards/components/shared/DatePicker";

const LoadingState = ({ t }) => (
  <div className="border border-white/10 rounded-sm p-12 text-center bg-black">
    <Loader2 className="animate-spin mx-auto mb-4 text-white" size={32} />
    <p className="text-xs font-mono uppercase tracking-[0.3em] text-gray-400">
      {t('Loading games...')}
    </p>
  </div>
);

const ErrorState = ({ t, message, onRetry }) => (
  <div className="border border-red-500/40 rounded-sm p-8 text-center bg-red-500/10 space-y-4">
    <AlertCircle className="mx-auto text-red-200" size={36} />
    <p className="text-xs font-mono uppercase tracking-[0.3em] text-red-200">
      {t('Error Loading Games')}
    </p>
    <p className="text-sm text-red-100/80">{message}</p>
    <button
      onClick={onRetry}
      className="px-6 py-3 border border-red-300/40 text-[11px] font-mono uppercase tracking-[0.3em] rounded-sm text-red-100 hover:border-red-100 transition-colors"
    >
      {t('Try Again')}
    </button>
  </div>
);

const EmptyState = ({ t }) => (
  <div className="border border-white/10 rounded-sm p-12 text-center bg-black space-y-3">
    <Calendar className="mx-auto text-white/30" size={36} />
    <p className="text-xs font-mono uppercase tracking-[0.3em] text-white/60">
      {t('No Games Found')}
    </p>
    <p className="text-[11px] text-white/40">
      {t('Try another date or filter combination.')}
    </p>
  </div>
);

const GamesView = ({
  filteredGames,
  totalGames,
  error,
  onRetry,
  renderGame,
  filters,
  onFilterChange,
  loading,
  onRefresh,
  statusFilters,
  t
}) => {
  const showInitialLoader = loading && totalGames === 0;
  const showEmptyState = !loading && !error && filteredGames.length === 0;

  return (
    <div className="space-y-6">
      <div className="border border-white/10 rounded-sm p-6 bg-white/[0.02]">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-black uppercase tracking-tight text-white flex items-center gap-3">
            {t('Games')} ({filteredGames.length})
          </h2>
          <p className="text-[11px] font-mono uppercase tracking-[0.3em] text-gray-500">
            {t('Filtered from')} {totalGames} {t('games')}
          </p>
        </div>

        {showInitialLoader && <LoadingState t={t} />}
        {error && <ErrorState t={t} message={error} onRetry={onRetry} />}
        {showEmptyState && <EmptyState t={t} />}

        {!showInitialLoader && !error && !showEmptyState && (
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {filteredGames.map(renderGame)}
          </div>
        )}
      </div>
    </div>
  );
};

export default GamesView;
